import { render, staticRenderFns } from "./inflection-browser-table.vue?vue&type=template&id=cc453238&"
import script from "./inflection-browser-table.vue?vue&type=script&lang=js&"
export * from "./inflection-browser-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc453238')) {
      api.createRecord('cc453238', component.options)
    } else {
      api.reload('cc453238', component.options)
    }
    module.hot.accept("./inflection-browser-table.vue?vue&type=template&id=cc453238&", function () {
      api.rerender('cc453238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections/inflection-browser-table.vue"
export default component.exports